<template>
  <nav  ref="navbar"  class="navbar navbar-expand-lg navbar-dark fixed" >
    <div class="container">
  <a class="navbar-brand" @click="reload()">
      <router-link :to="'/' + this.$route.params.lang ">
        <img src="./../assets/logo.png" width="110" height="auto" alt="">
      </router-link>
  </a>
    <button @click="manageClasses()"  ref="mobileMenuBtn" class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" ref="vociMenu" id="navbarTogglerDemo02">
      <ul v-if="this.$route.params.lang == 'it'"  class="navbar-nav mt-2 mt-lg-0">
        <li v-for="(item, index) of menuIt" :key="index"  class="nav-item ">
          <router-link class="nav-link"  :to="'/' + currentLang + '/'"  v-on:click.native="scrollMeTo(item.ref)" >{{item.label}}</router-link>
        </li>
      </ul>
      <ul v-else class="navbar-nav mt-2 mt-lg-0">
          <li v-for="(item, index) of menuEn" :key="index"  class="nav-item ">
          <router-link class="nav-link"  :to="'/' + currentLang + '/'"  v-on:click.native="scrollMeTo(item.ref)" >{{item.label}}</router-link>
        </li>
      </ul>
      <span class="separator">
          <a>|</a>
          </span>
          <ul class="lang-switch" @click="changeLang" :class="this.$route.params.lang == 'it' ? 'it' : 'en'">
            <li><a href="#">It</a></li>
            <li> / </li>
            <li><a href="#">En</a></li>
          </ul>
    </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Header',
  data:()=>{
    return {
      currentPage:"",
      currentRef:"",
      menuIt:[
        {
          label:"Lo Studio" ,
          ref:"studio"
        },
        {
          label:"I Soci",
          ref:"soci"
        },
        {
          label:"I Collaboratori",
          ref:"collaboratori"
        },
        {
          label:"Le Sedi",
          ref:"sedi"
        },
        {
          label:"Il Network",
          ref:"network"
        },
        {
          label:"Qualità",
          ref:"qualita"
        },
        {
          label:"Contatti",
          ref:"contatti"
        }
      ],
      menuEn:[
        {
          label:"The Firm" ,
          ref:"studio"
        },
        {
          label:"Partners",
          ref:"soci"
        },
        {
          label:"Team",
          ref:"collaboratori"
        },
        {
          label:"Offices",
          ref:"sedi"
        },
        {
          label:"Network",
          ref:"network"
        },
        {
          label:"Quality",
          ref:"qualita"
        },
        {
          label:"Contacts",
          ref:"contatti"
        }
      ]
    }
  },
  props: {
    msg: String,
  },
  computed:{
    currentLang(){
      return this.$route.param.lang
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  computed:{
    currentLang() {
      //console.log("currentLang",this.$route.params.lang);
      return this.$route.params.lang
    }
  },
  methods: {
    reload(){
      location.reload();
    },
    scrollMeTo(refName) {
      //console.log("refName",refName);
      this.currentRef = refName;

      this.$emit("scrollMeTo", this.currentRef)

    },
    manageClasses(){
      let yScrollValue = window.pageYOffset;
      if(yScrollValue==0) this.$refs.navbar.classList.toggle("sticky")
      
    },  
    changeLang() {

      let pageName = this.$route.params.pageName === undefined
         ? '/'
         : this.$route.params.pageName

      if(this.$route.params.lang == "it"){
        this.$router.push(`/en/`)
      } else {
        this.$router.push(`/it/`)
      }
		},
    handleScroll(){
      if(document.documentElement.scrollTop!=0){
        this.$refs.navbar.classList.add("sticky")
        
      } else if(document.documentElement.scrollTop ==0 && this.$refs.navbar.classList.contains("sticky")){
        this.$refs.navbar.classList.remove("sticky")
      }
    }
  },
  mounted() {
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.fixed {
  position: fixed;
  z-index: 999;
  width: 100%;
  top: 0;
}
.navbar {
  z-index: 999;
  transition: 0.2s ease;

    &:before{
        background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.363)), to(rgba(0, 0, 0, 0)));
        background-image: linear-gradient(rgba(0, 0, 0, 0.363), rgba(0, 0, 0, 0));
        content: "";
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        z-index: -1;
        height: 220px;
        transition: 0.2s ease;
    }
  .menu-container {
    display: flex;
    flex-direction: row-reverse;
  }
  a.nav-link  {
    color:#fff;
  }
  .navbar-dark .navbar-nav .nav-link:focus, .navbar-dark .navbar-nav .nav-link:hover,
  a.nav-link.active {
    color: #F04533;
  }
  .navbar-collapse {
    justify-content: flex-end;
  }
}

  .navbar-dark .navbar-nav .nav-link:focus, .navbar-dark .navbar-nav .nav-link:hover,
  a.nav-link.active {
    color: #F04533;
  }

.navbar-expand-lg .navbar-nav .nav-link{
  padding: 0px 1.1rem;
}
 
nav.sticky{
  background: #fff;
  
  transition: 0.2s ease;
  a.nav-link {
    transition: 0.2s ease;
    color:#1B1B19 ;
  }
    a.nav-link:hover {
    color:#797979;
  }
  
  &:before{
    opacity: 0;
    transition: 0.2s ease;
    display: none;
  }
  .lang-switch li,
  .lang-switch a{
    color: #000;
  }
}

.lang-switch {
  cursor: pointer;
  padding-left: 1rem;
    margin-bottom: 0px;
    display: flex;
  li {
    color: #fff;
    opacity: 0.5;
    padding: 0px 5px;
    a {
      color: #fff;
      pointer-events: none;
    }
  }
}
.lang-switch.it {
  li:first-child {
    opacity: 1;
  }
}
.lang-switch.en {
  li:last-child {
    opacity: 1;
  }
}
.separator {
    color: #fff;
    margin: 0px 10px;
}

/* MOBILE BEHAVIOUR TOGGLE*/


@media(max-width: 1280px){
  .navbar-expand-lg .navbar-nav .nav-link{
    padding: 0px 0.51rem;
  }
  .lang-switch {
    padding-left: 0.51rem;
  }
}
 
@media(max-width: 992px){
.navbar-collapse {
  &:before {
      background: #ffffff;
      width: 100%;
      height: 60px;
      display: block;
      display: none;
      content: "";
      position: absolute;
      top: 0;
      z-index: -1;
  }
  background: #fff;
    padding: 0.4rem 0px;
    margin: 0 -16px;
    .separator {
      display: none;
    }
    .lang-switch{
      padding-top: 10px;
      padding-bottom: 10px;
    }
    a,li {
        color: #000;
    }
    .navbar-nav{
  li {
    text-align: center;
    a.nav-link {
      color: #000;
      padding: 0.4rem 0px;

    }
    }
  }
  }
  .navbar-dark.sticky .navbar-toggler-icon {
    background-image:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e")
  }
}
@media(max-width: 768px){
.navbar-brand img {
  height: 50px;
  width: auto;
}
}
</style>
